import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PermDataSettingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"perm_data_setting"}/>
}
